import React, { createContext, useEffect, useState } from 'react';

import { getListViewState } from './utils';

import { CHOICES_DROPDOWN_ACTIVE } from '../routes/admin/utils/DropdownItems';

export const RecipeContext = createContext({});

export const RecipeProvider = ({ children }) => {
  const listViewStates = getListViewState();

  // Applied filters
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(CHOICES_DROPDOWN_ACTIVE()[0]);
  const [customParams, setCustomParams] = useState({});

  // Advanced filters
  const [advancedFilters, setAdvancedFilters] = useState(null);

  useEffect(() => {
    listViewStates.setCurrentPage(1);
  }, [selectedBrands, selectedStatus, customParams, advancedFilters]);

  return (
    <RecipeContext.Provider
      value={{
        ...listViewStates,
        selectedStatus,
        setSelectedStatus,
        selectedBrands,
        setSelectedBrands,
        advancedFilters,
        setAdvancedFilters,
        customParams,
        setCustomParams,
      }}
    >
      {children}
    </RecipeContext.Provider>
  );
};

export default RecipeContext;
